import { useEffect, useState } from 'react';

const DEFAULT_CAP = 85;
const TIMEOUT = 300;

const useProgressLoading = ({
  isLoading,
  progressTitles,
  expectedTime,
  capPercentage,
} :{
  isLoading: boolean;
  progressTitles: { label: string; min: number; max: number }[];
  expectedTime: number;
  capPercentage?: number;
}) => {
  const cap = capPercentage ?? DEFAULT_CAP;

  const [progress, setProgress] = useState(0);
  const [time, setTime] = useState(0);

  useEffect(() => {
    if (isLoading) {
      const timer = setInterval(() => {
        setProgress(cap * (1 - Math.exp(-time / (expectedTime / 3))));
        setTime(time + TIMEOUT);
      }, TIMEOUT);

      return () => {
        clearInterval(timer);
      };
    }

    return () => {
      setProgress(0);
      setTime(0);
    };
  }, [time, progress, isLoading, cap, expectedTime]);

  const finalProgress = isLoading ? progress : 100;

  const currentTitle = progressTitles.find(
    (title) => finalProgress >= title.min && finalProgress <= title.max,
  )?.label || 'Loading...';

  return {
    progress: finalProgress,
    progressTitle: currentTitle,
  };
};

export default useProgressLoading;
